import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginPageComponent } from "./components/login-page/login-page.component";
import { CreateVesselComponent } from "./components/create-vessel/create-vessel.component";
import { HomePageComponent } from "./components/home-page/home-page.component";
import { SailLoaderComponent } from "./components/shared/reusable/sail-loader/sail-loader.component";
import { CommonModule } from '@angular/common';
import { DataBridgeComponent } from "./components/databridge/databridge.component";
import { SnackbarComponent } from '@predigle/micro/component-ui';
import { ToastService } from './services/toast.service';
import { TourOverlayComponent } from "./features/learning-center/presentation/tour-overlay/tour-overlay.component";
import { TourCompletionDialogComponent } from "./features/learning-center/presentation/tour-completion-dialog/tour-completion-dialog.component";
import { LearningCenterComponent } from "./features/learning-center/presentation/learning-center/learning-center.component";
import { SkipperFloatingCompanionComponent } from "./features/skipper/presentation/skipper-floating-companion/skipper-floating-companion.component";
import { KeepItHostComponent } from "./features/keep-it/presentation/keep-it-host/keep-it-host.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoginPageComponent,
    CreateVesselComponent,
    HomePageComponent,
    SailLoaderComponent,
    CommonModule,
    DataBridgeComponent,
    SnackbarComponent,
    TourOverlayComponent,
    TourCompletionDialogComponent,
    LearningCenterComponent,
    SkipperFloatingCompanionComponent,
    KeepItHostComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'app-esperwave';

  constructor(public toast: ToastService) {}
}
